import styled from 'styled-components'
import theme from '../../../../styles/theme'

export const NumberRow = styled.span`
  font-family: ${theme.font.montserrat};
  font-size: 1rem;
  font-weight: ${theme.font.normal};
  color: ${theme.colors.white};
  background-color: ${theme.colors.primary};
  width: 30px;
  height: 30px;
  display: flex !important;
  border-radius: 50%;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  flex-direction: row;
  margin-right: 5px;
`

export const FormStyled = styled.form`
  max-height: 78vh;
  padding-bottom: 50px;
  overflow: auto;
  padding-right: 30px;
  ::-webkit-scrollbar {
    width: 8px;
  }

  ::-webkit-scrollbar-thumb {
    background: ${theme.colors.primary};
    border-radius: 10px;
  }
`

export const TitleRow = styled.h2`
  font-family: ${theme.font.montserrat};
  font-weight: ${theme.font.normal};
  font-size: 1.2rem;
  display: flex;
  align-items: center;
  margin-bottom: 0px;
  margin-top: 20px;
`
export const Row = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  input {
    width: 100%;
  }
  &.button-container {
    border-top: 1px solid ${theme.colors.gray};
    .buttons {
      width: 50%;
      display: flex;
      justify-content: end;
    }
    margin-top: 15px;
    padding-top: 20px;
    display: flex;
    flex-direction: row;
    .access-complete-register-button {
      background-color: transparent;
    }
    button {
      width: 100px;
    }
  }
  .required-msg {
    color: ${theme.colors.gray};
    font-style: italic;
    font-size: 0.9rem;
    font-family: ${theme.font.montserrat};
    font-weight: ${theme.font.normal};
  }
`
export const StyledRadio = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  flex-direction: row;
  span {
    width: 100%;
    margin-bottom: 10px;
  }
`
export const RadioOption = styled.input`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 17px;
  height: 17px;
  margin: 0;
  margin-right: 5px;
  input {
    width: 50%;
  }
`
export const LabelRadio = styled.label`
  font-size: 0.9rem;
  display: flex;
  align-items: center;
`
export const Tips = styled.div`
  svg,
  path {
    fill: ${theme.colors.primary};
    width: 30px;
    height: 30px;
    margin-right: 5px;
  }
  margin-top: 30px;
  margin-bottom: 30px;
  display: flex;
  font-size: 0.9rem;
  align-items: center;
  p {
    margin: 0;
    width: 80%;
  }
`
export const RowRadio = styled.label`
  display: flex;
  align-items: center;
  justify-content: space-between;
  /* flex-wrap: wrap; */
  & > div {
    width: 35%;
    margin-right: 15px;
  }
`
